module.exports = __webpack_public_path__ + "img/viagem-sonhos.7f94b4e4.png";